"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _inherits = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var LogLevel_1 = require("./LogLevel");
var NoOpLogger_1 = require("./NoOpLogger");
/**
 * [[NoOpDebugLogger]] does not log any message but does call
 * debug functions by default.
 */
var NoOpDebugLogger = /*#__PURE__*/function (_NoOpLogger_1$default) {
  _inherits(NoOpDebugLogger, _NoOpLogger_1$default);
  function NoOpDebugLogger() {
    _classCallCheck(this, NoOpDebugLogger);
    return _possibleConstructorReturn(this, _getPrototypeOf(NoOpDebugLogger).call(this, LogLevel_1.default.DEBUG));
  }
  return NoOpDebugLogger;
}(NoOpLogger_1.default);
exports.default = NoOpDebugLogger;